<script lang="ts">
 import { onMount } from 'svelte';
 let token = $state(''), password = $state(''), confirmation = $state('');
 let busy = $state(false), error = $state(''), saved = $state(false);
 onMount(()=>{
  token = new URLSearchParams(window.location.hash.split('?')[1] || '').get('token') || '';
  // Keep the bearer token only in component memory, not URL history/storage.
  history.replaceState(null,'',window.location.pathname+window.location.search+'#/password/setup');
  if(!/^[a-f0-9]{64}$/.test(token)) error='This link is missing or invalid. Request a new invitation or password-reset link.';
 });
 async function submit(){
  if(busy||saved)return;error='';
  const size=new TextEncoder().encode(password).length;
  if(size<12||size>72){error='Use a password between 12 and 72 bytes.';return;}
  if(password!==confirmation){error='Passwords do not match.';return;}
  busy=true;
  try{
   const response=await fetch('/credential-links/redeem',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({token,password})});
   if(!response.ok)throw new Error(response.status===400?'This link is invalid, expired or already used. Request a new link.':response.status===429?'Too many attempts. Please try again later.':'Unable to save your password. Please try again.');
   saved=true;token='';password='';confirmation='';
  }catch(e){error=e instanceof Error?e.message:'Unable to save password.';}finally{busy=false;}
 }
</script>
<main class="max-w-md mx-auto my-12 p-6 space-y-5">
 <h1 class="text-2xl font-bold">Set your password</h1>
 {#if error}<p role="alert" class="alert alert-error">{error}</p>{/if}
 {#if saved}<p role="status">Your password has been saved and previous sessions revoked.</p><a class="btn btn-primary" href="#/login">Sign in</a>
 {:else}<p>This link can be used once. Choose your own password to finish account setup or recovery.</p>
 <form class="space-y-4" onsubmit={(e)=>{e.preventDefault();void submit();}}>
  <label class="block">New password<input class="input w-full" type="password" autocomplete="new-password" required bind:value={password} disabled={busy}/></label>
  <label class="block">Confirm password<input class="input w-full" type="password" autocomplete="new-password" required bind:value={confirmation} disabled={busy}/></label>
  <p class="text-sm">12–72 bytes. A long, unique passphrase works well.</p>
  <button class="btn btn-primary" disabled={busy||!token}>{busy?'Saving…':'Save password'}</button>
 </form>{/if}
</main>
